// A confirmation the user just gave, held briefly in memory.
//
// The server accepts a re-authentication token for a few minutes, so asking for
// the PIN again inside that window protects nothing and only gets in the way —
// looking at a card's number twice in a row shouldn't mean typing it twice.
//
// Memory only: never written to storage, and dropped on sign-out so the next
// person to open the app always has to confirm.

let token: string | null = null;
let expiresAt = 0;

/** Slightly shorter than the server's own window, so a cached token can't be
 *  handed over just as it expires. */
const LIFETIME_MS = 4 * 60_000;

export function cacheReauth(t: string | undefined): void {
  if (!t) return;
  token = t;
  expiresAt = Date.now() + LIFETIME_MS;
}

/** A still-valid confirmation, or undefined when the user must confirm again. */
export function cachedReauth(): string | undefined {
  return token && Date.now() < expiresAt ? token : undefined;
}

export function clearReauth(): void {
  token = null;
  expiresAt = 0;
}
